import { appRequest } from 'api/appRequest'

export const getProductRecommendationSelecteds = async <T>(params: T) =>
	await appRequest('api/dior/product_recommendation_selecteds', {
		params,
	})
